export const SentryLoader = () =>
  process.env.NEXT_PUBLIC_SENTRY_DSN ? (
    <script
      src={`https://js.sentry-cdn.com/${process.env.NEXT_PUBLIC_SENTRY_DSN}.min.js`}
      crossOrigin="anonymous"
    />
  ) : null;
